// extracted by mini-css-extract-plugin
export var badge = "_h3-2";
export var detailsPanel = "_h3-0";
export var resultRow = "_h3-1";